'use strict';

export default class MemFeeViewCtrl {
  constructor($stateParams, $state, LoaderSvc, MemFeeSvc, MemFeeAmtModalSvc,
    GroupAuthSvc) {
    var that = this;
    var groupId = $stateParams.groupId;
    this.groupId = groupId; // current group
    this.mfId = $stateParams.mfId;

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'memberFee', 'R');

    if(!this.mfId) {
      return $state.go('group.view.settings.memberFee.list');
    }
    //load memberFee
    function loadMemberFee() {
      LoaderSvc.start();
      MemFeeSvc.get({groupId: that.groupId, id: that.mfId}).$promise
        .then(function(memberFee) {
          that.memberFee = memberFee;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Member Fee');
        });
    }
    loadMemberFee();

    this.openAmounts = function(memFee, amtType) {
      MemFeeAmtModalSvc.open(memFee, amtType, that.groupId).then(function() {
        loadMemberFee();
      });
    };
  }
}

MemFeeViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'LoaderSvc',
  'MemFeeSvc',
  'MemFeeAmtModalSvc',
  'GroupAuthSvc'
];
